import { MDBBtn, MDBChipsInput, MDBIcon } from "mdb-react-ui-kit";
import { forwardRef } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { createFreshdeskProfile } from "../../../apiclients/streamsapi_bridge";



export const AddProfile = forwardRef(({setIsloading, onClose}, ref) => {
    const { t, i18n } = useTranslation();


    const { register, formState, getValues, handleSubmit, setError, clearErrors, reset, watch } = useForm({
        defaultValues: {
            domain: "",
            api_key: "",
            profile_name: "",
            pstn_acd_call_accepted: 1,
            pstn_inbound_call_accepted: 1
        }
      });

      const { errors, isDirty } = formState;



    const onsubmit = async (data) => {
        let updates = {};


        console.log(`isDirty value is ${isDirty}`);
        if(isDirty){
            updates = {
                reqid : 118,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                profile_name : data.profile_name,
                domain : data.domain,
                api_key : data.api_key,
                pstn_acd_call_accepted : data.pstn_acd_call_accepted,
                pstn_inbound_call_accepted : data.pstn_inbound_call_accepted
            }
            console.log(`inside if : updates of add freshdesk profile is ${JSON.stringify(updates)}`);
        }

        console.log(`updates of add freshdesk profile is ${JSON.stringify(updates)}`);

        setIsloading(true);
    let saverep = await createFreshdeskProfile(updates);
    console.log(`reponse of add profile :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(`reponse of add profile after:::: ${JSON.stringify(saverepeMsg)}`);
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      localStorage.setItem("s_message", "Profile created successfully.");
      window.location.href = "/apilanding";
      onClose();     


    } else {
        if (saverepeMsg.message?.errors) {
            saverepeMsg.message.errors.forEach((err) => {
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
              const fieldElement = document.querySelector(
                `input[name="${err.param_name}"]`
              );
              if (fieldElement) {
                fieldElement.focus();
              }
            });
          }

    }

    }


    return (
        <>
         <form>
        
        <div className="tel-numbers mt-2">
                        <strong>API Profile Name</strong>
                      </div>
                      <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" 
                        {...register("profile_name",{ required: "API Profile Name is required" })}
                        />
                        {errors?.profile_name && (
                            <p className="text-danger">
                                {errors?.profile_name?.message}
                            </p>
                        )}
                      </div>
                      <div
                        className="general-settings mt-3"
                        id="CallingandSMS"
                      >Freshdesk Domain and API Key
                      </div>

                      <div className="tel-numbers mt-2">
                        <strong>Domain</strong>
                      </div>

                      <div className="phoneselect d-flex flex-row align-items-center">
                        <span>https:// </span>
                        <input className='form-control' placeholder='Freshdesk' 
                        {...register("domain",{ required: "Domain is required" })}
                        />
                        <span>.freshdesk.com </span>
                      </div>
                      {errors?.domain && (
                            <p className="text-danger">
                                {errors?.domain?.message}
                            </p>
                        )}

                      <div className="tel-numbers mt-2">
                        <strong>API Key</strong>
                      </div>
                      <div className="form pt-1 w-100">
                        <input type="text" className="w-100 form-control" 
                        {...register("api_key", { required: "API key is required" })}
                        />
                         {errors?.api_key && (
                            <p className="text-danger">
                                {errors?.api_key?.message}
                            </p>
                        )}
                      </div>
                      <div style={{ display: "none" }}>
						<button ref={ref} 
                        onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}
                        >
							{t("add")}</button>
					</div>
                    </form>
        
        </>

    );
});